import { Credit } from '../../models/credit';

export interface PackHttp {
  id: string;
  credit_total: number;
  credit_free?: number;
  price_net: number;
  price_gross: number;
  special_label?: string;
  special_description?: string;
}

export interface OffersHttp {
  items: PackHttp[];
  total_results: number;
}

export const fromPackHttpToPack = (packHttp: PackHttp): Credit.Pack => {
  return {
    id: packHttp.id,
    creditTotal: packHttp.credit_total,
    specialLabel: packHttp.special_label ? packHttp.special_label : '',
  };
};
